import WithRender from "../../templates/imageEditor/canvasEditor.html";
import { mapGetters } from "vuex";

import ImageContainer from "../imageEditor/ImageContainer";
import FormatEditor from "../imageEditor/FormatEditor";

export default WithRender({
  components: {
    appImageContainer: ImageContainer,
    appFormatEditor: FormatEditor
  },
  computed: {
    ...mapGetters([
      "getFullFormatDim",
      "getFullMargins",
      "getMargin",
      "getFormat",
      "getThickness",
      "getReady",
      "getEditor",
      "getImage"
    ]),
    fullFormat: function () {
      return this.getFullFormatDim;
    },
    zoom: function () {
      return this.getEditor.zoom;
    },
    fullMargins: function () {
      return this.getFullMargins;
    },
    margins: function () {
      return this.getMargin;
    },
    thickness: function () {
      return this.getThickness.thickness;
    },
    format: function () {
      return this.getFormat;
    },
    originalImage: function () {
      return this.getImage.original;
    },
    getCanvasDim: function () {
      if (this.getReady) {
        var dim = this.getEditor.dim.canvasDimByFormat;
        return {
          width: dim.width + "px",
          height: dim.height + "px",
          top: dim.top + "px",
          left: dim.left + "px"
        };
      }
    },
    detectChanges: function () {
      return [
        this.fullFormat,
        this.getReady,
        this.getEditor.width,
        this.getEditor.height,
        this.margins.type
      ];
    }
  },
  methods: {
    calculateCanvasDim: function () {
      var dim = {
        top: 0,
        left: 0,
        width: this.getEditor.width,
        height: this.getEditor.height,
        error: 0
      };
      try {
        var dims = this.getEditor.dim.imageDimByFormat;
        var inh = dims.height;
        var inw = dims.width;
        var targetRatio = this.getEditor.width / this.getEditor.height;
        var sourceRatio = inw / inh;
        var unit = 0;
        if (sourceRatio > targetRatio) {
          unit = inw / this.getEditor.width;
          /*var ch     = this.editor.width / sourceRatio;*/
          var ch = inh / unit;
          dim.top = Math.round((this.getEditor.height - ch) / 2);
          dim.height = Math.round(ch);
          dim.width = Math.round(this.getEditor.width);
          dim.height_fix = ch;
          dim.width_fix = this.getEditor.width;
          dim.left = 0;
        } else {
          unit = inh / this.getEditor.height;
          /*var cw     = this.editor.height * sourceRatio;*/
          var cw = inw / unit;
          dim.top = 0;
          dim.height = Math.round(this.getEditor.height);
          dim.width = Math.round(cw);
          dim.height_fix = this.getEditor.height;
          dim.width_fix = cw;
          dim.left = Math.round((this.getEditor.width - cw) / 2);
        }
        this.$store.commit("changeCanvasDimByFormat", {
          unit: unit,
          width: dim.width,
          height: dim.height,
          width_fix: dim.width_fix,
          height_fix: dim.height_fix,
          top: dim.top,
          left: dim.left
        });
      } catch (err) {
        dim.error = err.message;
      }
      return dim;
    },
    computeImageDimsByFormat: function () {
      try {
        var localFormat = this.format;
        var localMargins = this.fullMargins;
        var margins = this.margins;
        var fullFormat = this.fullFormat;
        var originalImage = this.originalImage;
        if (margins.type < 0) {
          localFormat = fullFormat; //inner
          localMargins = { width: 0, height: 0 };
        }
        var ch = (originalImage.width * localFormat.height) / localFormat.width;
        var cw =
          (originalImage.height * localFormat.width) / localFormat.height;
        var unit = 0;
        if (ch >= originalImage.height) {
          unit = originalImage.height / localFormat.height;
        } else if (cw >= originalImage.width) {
          unit = originalImage.width / localFormat.width;
        }
        var inw_cm = originalImage.width / unit;
        var inh_cm = originalImage.height / unit;
        /*var inw = originalImage.width + localMargins.width * unit;
                                   var inh = originalImage.height + localMargins.height * unit;*/
        var inw = (inw_cm + localMargins.width) * unit;
        var inh = (inh_cm + localMargins.height) * unit;
        this.$store.commit("changeImageDimByFormat", {
          unit: unit,
          width: inw,
          height: inh,
          width_cm: inw_cm,
          height_cm: inh_cm
        });
      } catch (err) {
        console.log(err);
      }
    },
    calculateImageDim: function () {
      var imageDimByFormat = this.getEditor.dim.imageDimByFormat;
      var margins = this.margins;
      var thickness = this.thickness;
      var editorCanvasByFormat = this.getEditor.dim.canvasDimByFormat;
      var unit = imageDimByFormat.unit / editorCanvasByFormat.unit;

      var top1 = Math.round((margins.top + thickness) * unit);
      var right1 = Math.round((margins.right + thickness) * unit);
      var bottom1 = Math.round((margins.bottom + thickness) * unit);
      var left1 = Math.round((margins.left + thickness) * unit);

      if (margins.type > 0) {
        var top = top1;
        var right = right1;
        var bottom = bottom1;
        var left = left1;
      } else {
        var top = 0;
        var right = 0;
        var bottom = 0;
        var left = 0;
      }

      var width = editorCanvasByFormat.width - left - right;
      var height = editorCanvasByFormat.height - top - bottom;

      this.$store.commit("changeCanvasImageDimByFormat", {
        width: width,
        height: height,
        top: top1,
        left: left1,
        bottom: bottom1,
        right: right1
      });
    },
    calculateFormatDim: function () {
      var imageDimByFormat = this.getEditor.dim.imageDimByFormat;
      var editorCanvasByFormat = this.getEditor.dim.canvasDimByFormat;
      var fullFormat = this.fullFormat;

      var width = 0;
      var height = 0;
      var width_fix = 0;
      var height_fix = 0;
      var top = 0;
      var left = 0;
      var bottom = 0;
      var right = 0;
      var type = 1;

      var targetRatio =
        editorCanvasByFormat.width / editorCanvasByFormat.height;
      var sourceRatio = fullFormat.width / fullFormat.height;

      if (sourceRatio > targetRatio) {
        width = editorCanvasByFormat.width;
        height = Math.round(
          (fullFormat.height *
            imageDimByFormat.unit *
            editorCanvasByFormat.width) /
            imageDimByFormat.width
        );
        width_fix = editorCanvasByFormat.width_fix;
        height_fix =
          (fullFormat.height *
            imageDimByFormat.unit *
            editorCanvasByFormat.width_fix) /
          imageDimByFormat.width;
        top = Math.round((editorCanvasByFormat.height - height) / 2);
        bottom = Math.round((editorCanvasByFormat.height - height) / 2);
        type = 1;
      } else {
        height = editorCanvasByFormat.height;
        width = Math.round(
          (fullFormat.width *
            imageDimByFormat.unit *
            editorCanvasByFormat.height) /
            imageDimByFormat.height
        );
        height_fix = editorCanvasByFormat.height_fix;
        width_fix =
          (fullFormat.width *
            imageDimByFormat.unit *
            editorCanvasByFormat.height_fix) /
          imageDimByFormat.height;
        left = Math.round((editorCanvasByFormat.width - width) / 2);
        right = Math.round((editorCanvasByFormat.width - width) / 2);
        type = 2;
      }

      this.$store.commit("changeFormat", { prop: "type", value: type });

      this.$store.commit("changeCanvasFormatDimByFormat", {
        width: width,
        height: height,
        width_fix: width_fix,
        height_fix: height_fix,
        top: top,
        left: left,
        bottom: bottom,
        right: right
      });
    }
  },
  watch: {
    detectChanges: {
      handler: function () {
        if (this.getReady) {
          this.computeImageDimsByFormat();
          this.calculateCanvasDim();
          this.calculateFormatDim();
          this.calculateImageDim();
        }
      },
      deep: true
    },
    zoom: {
      handler: function () {
        if (this.getReady) {
          this.$nextTick(
            (function (that) {
              return function () {
                that.$store.dispatch("updateBgOnResize", {});
              };
            })(this)
          );
        }
      },
      deep: true
    }
  },
  mounted: function () {
    const oieCanvas = $(this.$refs.oieCanvasRef);
    $(oieCanvas).on("click", event => {
      if ($(event.target).closest(".rectangle-item").length) return;
      this.$store.commit("emptyActiveElement");
    });
  }
});
